import { create } from "zustand";

export type DraftCaptureMethod = "direct" | "manual_upload";

export interface DraftAttachment {
  id: string; // client-generated, e.g. crypto.randomUUID()
  blob: Blob;
  filename: string;
  captureMethod: DraftCaptureMethod;
}

interface TicketDraftState {
  attachments: DraftAttachment[];
  addAttachment: (attachment: DraftAttachment) => void;
  removeAttachment: (id: string) => void;
  clear: () => void;
}

/**
 * ADR-110: holds attachments queued for a ticket BEFORE it is submitted.
 * This lets the user land on the ticket page with the auto-captured
 * screenshot already attached, and still add more documents (direct or
 * manual) before hitting submit. Nothing here is persisted to the backend
 * until the ticket's submit action runs.
 */
export const useTicketDraftStore = create<TicketDraftState>((set) => ({
  attachments: [],
  addAttachment: (attachment) =>
    set((state) => ({ attachments: [...state.attachments, attachment] })),
  removeAttachment: (id) =>
    set((state) => ({
      attachments: state.attachments.filter((a) => a.id !== id),
    })),
  clear: () => set({ attachments: [] }),
}));
